import React, { useState } from "react";
import { Icon, notification, Row, Upload } from "antd";
import { useSelector } from "react-redux";
import ButtonStandard from "../../utils/button";
import {
  parseInvoiceAutoDetect,
  parseNfeDanfePdf,
  parseNfeXml,
} from "../../../services/invoiceService";
import DanfeContent from "./DanfeContent";
import { ButtonsRow, Container, FileNameLabel } from "./styles";

const InvoiceUploadViewer = ({ value, onChange, disabled }) => {
  const { translation } = useSelector((state) => state.app);
  const t = translation?.invoiceUploadViewer;

  const [file, setFile] = useState(value?.file || null);
  const [invoice, setInvoice] = useState(value?.invoice || null);
  const [loadingType, setLoadingType] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const parseFile = async (type, uploadedFile, parseFn, errorMessage) => {
    setLoadingType(type);
    try {
      const { data: parsedInvoice } = await parseFn({ file: uploadedFile });
      setFile(uploadedFile);
      setInvoice(parsedInvoice);
      if (onChange) {
        onChange(uploadedFile, parsedInvoice);
      }
    } catch (error) {
      notification.error({
        message: errorMessage,
      });
    } finally {
      setLoadingType(null);
    }
  };

  const handleBeforeUploadXml = (uploadedFile) => {
    parseFile("xml", uploadedFile, parseNfeXml, t.errors.parseXml);
    return false;
  };

  const handleBeforeUploadPdf = (uploadedFile) => {
    parseFile("pdf", uploadedFile, parseInvoiceAutoDetect, t.errors.parsePdf);
    return false;
  };

  return (
    <>
      <Row type="flex" justify="center">
        {file && <FileNameLabel>Arquivo: {file.name}</FileNameLabel>}
      </Row>
      <ButtonsRow>
        <Upload
          accept=".xml"
          showUploadList={false}
          disabled={disabled || loadingType !== null}
          beforeUpload={handleBeforeUploadXml}
        >
          <ButtonStandard
            type="button"
            buttonType="secondary"
            disabled={disabled || loadingType !== null}
          >
            <Icon type={loadingType === "xml" ? "loading" : "upload"} />
            {t.buttons.loadXml}
          </ButtonStandard>
        </Upload>

        <Upload
          accept=".pdf"
          showUploadList={false}
          disabled={disabled || loadingType !== null}
          beforeUpload={handleBeforeUploadPdf}
        >
          <ButtonStandard
            type="button"
            buttonType="secondary"
            disabled={disabled || loadingType !== null}
          >
            <Icon type={loadingType === "pdf" ? "loading" : "upload"} />
            {t.buttons.loadPdf}
          </ButtonStandard>
        </Upload>

        <ButtonStandard
          type="button"
          buttonType="typeWithoutBackgroundWithBorder"
          disabled={!invoice}
          onClick={() => setDrawerVisible(true)}
        >
          <Icon type="eye" />
          {t.buttons.viewDocument}
        </ButtonStandard>
      </ButtonsRow>

      <Container
        title={t.drawer.title}
        visible={drawerVisible}
        placement="right"
        width={720}
        onClose={() => setDrawerVisible(false)}
      >
        <DanfeContent invoice={invoice} t={t.drawer} />
      </Container>
    </>
  );
};

export default InvoiceUploadViewer;
